import { render, staticRenderFns } from "./MotivoPerda.vue?vue&type=template&id=949580a4&"
import script from "./MotivoPerda.vue?vue&type=script&lang=js&"
export * from "./MotivoPerda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports